import { MarcaOrigem } from '@/global/components/MarcaOrigem'
import { SelectField } from '@/global/components/SelectField'
import Grid from '@/global/components/ui/Grid'
import { Origens } from '@acme/common'
import { StatusAprovacao } from '@acme/core'
import {
    FormDatePicker,
    FormField,
    FormFieldSelect,
    FormFile,
} from 'global/components/Form'
import { useFormContext } from 'react-hook-form'
import { match } from 'ts-pattern'
import { AutocompleteDescricaoAbono } from './NovoAbono'

const ORIGENS = Object.entries(Origens).map(([chave, rotulo]) => ({
    value: Number(chave),
    label: rotulo,
}))

export default function FormDetalhesAbono() {
    const { watch } = useFormContext()
    const [origem, statusAprovacao] = watch(['origem', 'statusAprovacao'])

    return (
        <Grid container>
            <Grid item xs={6}>
                <FormDatePicker name="data" label="Data" type="date" required />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="quantidadeHoras"
                    label="Horas abonadas"
                    required
                />
            </Grid>
            <Grid item xs={6}>
                <SelectField
                    label="Origem"
                    variant="filled"
                    disabled
                    options={ORIGENS}
                    value={origem}
                    onValueChange={() => {}}
                    unHelperText={false}
                    endAdornment={<MarcaOrigem origem={origem} />}
                    className="mb-2"
                />
            </Grid>
            <Grid item xs={6}>
                <FormFieldSelect
                    name="tipo"
                    label="Tipo"
                    options={[
                        { label: 'Normal', value: 'NORMAL' },
                        {
                            label: 'Saúde ocupacional',
                            value: 'SAUDE_OCUPACIONAL',
                        },
                    ]}
                />
            </Grid>
            <Grid item xs={12}>
                <AutocompleteDescricaoAbono />
            </Grid>
            <FormField name="id" className="hidden!" />
            <Grid item xs={12}>
                <FormFile name="fileUrl" disabled />
            </Grid>
            {match(statusAprovacao)
                .with(StatusAprovacao.PENDENTE, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Motivo da inclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .with(StatusAprovacao.PENDENTE_EXCLUSAO, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="MotivoExclusao.motivo"
                            label="Motivo da exclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .otherwise(() => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Justificativa"
                            multiline
                        />
                    </Grid>
                ))}
        </Grid>
    )
}
